import SectionHeading from "@/components/base/SectionHeading";
import DramaCard from "@/components/feature/DramaCard";
import { dramas } from "@/mocks/dramas";

export default function LatestEpisodes() {
  const latest = [...dramas].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, 8);

  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="LATEST UPDATES"
        title="最新剧集推荐"
        desc="追踪“出轨的味道”系列及相关都市情感悬疑剧集的最新更新与完结动态。"
        moreHref="/category"
        moreLabel="进入分类页"
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {latest.map((drama) => (
          <DramaCard key={drama.id} drama={drama} />
        ))}
      </div>
    </section>
  );
}